export const athleteCard = {
  background: 'rgba(255, 255, 255, 0.01)',
  border: '0.01rem solid rgba(255, 255, 255, 0.1)',
  width: '100%',
  borderRadius: '1rem!important',
  overflow: 'auto',
  height: '55%',
};
